<div id="orGlobalAdministration" class="or-content">
  <div class="or-content-header">
    <ul class="or-inline-items or-pull-left">
      <li class="or-inline-item">
        <app-tabs [tabs$]="tabs$"></app-tabs>
      </li>
    </ul>
  </div>
  <router-outlet></router-outlet>
</div>